export enum ERoleAccess {
	// Any (1)
	Any = 'any',
	// Api (2)
	ApiHealthCheck = 'api:healthCheck',
	ApiPostbackSend = 'api:postbackSend',
	// Auth (2)
	AuthLogin = 'auth:login',
	AuthProfile = 'auth:profile',
	// Common (3)
	CommonCountryAny = 'common:country:any',
	CommonCountryList = 'common:country:list',
	CommonCountryRead = 'common:country:read',
	// Common (3)
	CommonLanguageAny = 'common:language:any',
	CommonLanguageList = 'common:language:list',
	CommonLanguageRead = 'common:language:read',
	// Common (3)
	CommonTimeZoneAny = 'common:timeZone:any',
	CommonTimeZoneList = 'common:timeZone:list',
	CommonTimeZoneRead = 'common:timeZone:read',
	// Role (6)
	RoleAny = 'role:any',
	RoleList = 'role:list',
	RoleRead = 'role:read',
	RoleCreate = 'role:create',
	RoleModify = 'role:update',
	RoleRemove = 'role:remove',
	// Account (8)
	AccountAny = 'account:any',
	AccountList = 'account:list',
	AccountIsFiredList = 'account:fired:list',
	AccountRead = 'account:read',
	AccountCreate = 'account:create',
	AccountModify = 'account:update',
	AccountRemove = 'account:remove',
	AccountResurrect = 'account:resurrect',
	// AccountBuyer (3)
	AccountBuyerAny = 'account:buyer:any',
	AccountBuyerList = 'account:buyer:list',
	AccountBuyerSelf = 'account:buyer:self',
	// AccountTeam (3)
	AccountTeamAny = 'account:team:any',
	AccountTeamList = 'account:team:list',
	AccountTeamSelf = 'account:team:self',
	// Affiliate (6)
	AffiliateAny = 'affiliate:any',
	AffiliateList = 'affiliate:list',
	AffiliateRead = 'affiliate:read',
	AffiliateCreate = 'affiliate:create',
	AffiliateModify = 'affiliate:update',
	AffiliateRemove = 'affiliate:remove',
	// OfferScope (6)
	OfferScopeAny = 'offer.scope:any',
	OfferScopeList = 'offer.scope:list',
	OfferScopeRead = 'offer.scope:read',
	OfferScopeCreate = 'offer.scope:create',
	OfferScopeModify = 'offer.scope:update',
	OfferScopeRemove = 'offer.scope:remove',
	// Offer (10)
	OfferAny = 'offer:any',
	OfferAnyGroup = 'offer:any:group',
	OfferList = 'offer:list',
	OfferRead = 'offer:read',
	OfferCreate = 'offer:create',
	OfferModify = 'offer:update',
	OfferRemove = 'offer:remove',
	OfferResurrect = 'offer:resurrect',
	OfferBind = 'offer:bind',
	OfferUnbind = 'offer:unbind',
	// OfferSpend (9)
	OfferSpendAny = 'offer.spend:any',
	OfferSpendAnyAccount = 'offer.spend:any:account',
	OfferSpendAnyDay = 'offer.spend:any:day',
	OfferSpendAnyGroup = 'offer.spend:any:group',
	OfferSpendList = 'offer.spend:list',
	OfferSpendRead = 'offer.spend:read',
	OfferSpendCreate = 'offer.spend:create',
	OfferSpendModify = 'offer.spend:update',
	OfferSpendRemove = 'offer.spend:remove',
	// OfferSpendBy (4)
	OfferSpendByAny = 'offer.spend:by:any',
	OfferSpendByAccountList = 'offer.spend:by:account:list',
	OfferSpendByOfferList = 'offer.spend:by:offer:list',
	OfferSpendByOfferScopeList = 'offer.spend:by:offer:scope:list',
	// Revenue (6)
	RevenueAny = 'revenue:any',
	RevenueList = 'revenue:list',
	RevenueRead = 'revenue:read',
	RevenueCreate = 'revenue:create',
	RevenueModify = 'revenue:update',
	RevenueRemove = 'revenue:remove',
	// RevenueAgency (6)
	RevenueAgencyAny = 'revenue.agency:any',
	RevenueAgencyList = 'revenue.agency:list',
	RevenueAgencyRead = 'revenue.agency:read',
	RevenueAgencyCreate = 'revenue.agency:create',
	RevenueAgencyModify = 'revenue.agency:update',
	RevenueAgencyRemove = 'revenue.agency:remove',
	// RevenueSpend (8)
	RevenueSpendAny = 'revenue.spend:any',
	RevenueSpendAnyAccount = 'revenue.spend:any:account',
	RevenueSpendAnyDay = 'revenue.spend:any:day',
	RevenueSpendList = 'revenue.spend:list',
	RevenueSpendRead = 'revenue.spend:read',
	RevenueSpendCreate = 'revenue.spend:create',
	RevenueSpendModify = 'revenue.spend:update',
	RevenueSpendRemove = 'revenue.spend:remove',
	// RevenueSpendBy (5)
	RevenueSpendByAny = 'revenue.spend:by:any',
	RevenueSpendByAccountList = 'revenue.spend:by:account:list',
	RevenueSpendByAccountsList = 'revenue.spend:by:accounts:list',
	RevenueSpendByTeamList = 'revenue.spend:by:team:list',
	RevenueSpendByTeamsList = 'revenue.spend:by:teams:list',
	// Debug (4)
	DebugAny = 'debug:any',
	DebugCronRunner = 'debug:cron:runner',
	DebugDraft = 'debug:draft',
	DebugMessage = 'debug:message',
	// Job (6)
	JobAny = 'job:any',
	JobList = 'job:list',
	JobRead = 'job:read',
	JobCreate = 'job:create',
	JobModify = 'job:update',
	JobRemove = 'job:remove',
	// Project (6)
	ProjectAny = 'project:any',
	ProjectList = 'project:list',
	ProjectRead = 'project:read',
	ProjectCreate = 'project:create',
	ProjectModify = 'project:update',
	ProjectRemove = 'project:remove',
	//
}
